<template>
    <div class="base-form-div audio-room" v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-form size="mini" :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="接收方卡号">
                <el-input :disabled="true" v-model="ruleForm.receiveCardNumber"></el-input>
            </el-form-item>
        </el-form>
        <div class="audio-list">
            <div v-for="item in audioList" :class="item.type === 1 ? 'right' : 'left'" class="msg-item">
                <span>卡号:{{ item.type === 1 ? '本机' : item.sendCardNumber }}(时间:{{ item.createTime }})</span>
                <audio controls v-if="item.type === 0" class="infoImg" :src="`${API_Server}/voiceFile/` + item.content">
                </audio>
                <audio controls v-else class=" infoImg" :src="`${API_Server}/voiceSendFile/` + item.content">
                </audio>
            </div>
            <el-empty v-show="!loading && (!audioList || audioList.length < 1)" description="暂无数据"></el-empty>
        </div>
        <div class="form-bottom">
            <el-button :disabled="start" class="base-button" size="mini" type="primary" @click="startAudio">开始录音</el-button>
            <el-button :disabled="!start" class="base-button" size="mini" type="primary" @click="stopAudio">停止录音</el-button>
            <el-button :disabled="!stop" class="base-button" size="mini" type="primary" @click="openAudio">播放</el-button>
            <el-button class="base-button" size="mini" type="primary" @click="reset">重置</el-button>
            <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">发送</el-button>
        </div>
        <audio id="myAudio" :src="audioUrl"></audio>
        <div v-if="showTime" class="bottomMsg">
            <span>录音倒计时:</span>
            <count-down v-on:start_callback="countDownS_cb(1)" v-on:end_callback="countDownE_cb(1)" :currentTime="startTime"
                :startTime="startTime" :endTime="endTime" :secondsTxt="'秒'"></count-down>
        </div>

    </div>
</template>
<script>
//{"receiveCardNumber":"9123456"}
///system/zhj/getZhjBdCardList
import RecorderWav from './RecorderWav.js'
import { postCommonAjax, getCommonAjax } from "@/api/common"
import CountDown from 'vue2-countdown'
let recorderWavUti = undefined;
export default {
    components: {
        CountDown
    },
    props: ["subData"],
    data() {
        return {
            API_Server: window.API_Server,
            audioList: [],
            audioUrl: "",
            stop: false,
            start: false,
            startTime: undefined,
            endTime: undefined,
            ruleForm: {
                receiveCardNumber: undefined,
                file: undefined
            },
            zhjMap: {
                "1": 2,
                "2": 4,
                "3": 9,
                "4": 15,
                "5": 25,
            },
            sumTime: 2,
            showTime: false,
            loading: true
        };
    },
    methods: {
        // 查询历史消息
        getHistoryMessage(cardNumber) {
            let that = this;
            getCommonAjax('/message/pageMessageWav', {
                page: `1`,
                pageSize: `100`,
                number: cardNumber,
                beginTime: `2023-01-01 00:00:00`,
                endTime: `4023-12-31 00:00:00`
            }).then(res => {
                var items = res.result || [];
                this.audioList = items;
                that.loading = false
            }).catch(err => {
                console.error(err);
                that.loading = false
            });
        },
        getZhjMsg() {
            getCommonAjax("/system/zhj/getZhjBdCardList", {}).then(res => {
                var obj = res.result[0];
                var rdcd = obj.rdcd + "";
                this.sumTime = this.zhjMap[rdcd];
            }).catch(err => {
                console.error(err);
            });
        },
        getTimeStampAfterSeconds(n) {
            const currentTimestamp = Date.now();
            const secondsInMillis = n * 1000;
            const futureTimestamp = currentTimestamp + secondsInMillis;
            return futureTimestamp;
        },
        countDownS_cb() {
            console.log("计时开始")
        },
        countDownE_cb() {
            this.stopAudio();
            console.log("计时结束")
        },
        startAudio() {
            this.start = true;
            recorderWavUti.start();
        },

        startAudioBack() {
            this.start = true;
            var that = this;
            // 设置录制参数
            const options = {
                audio: {
                    mimeType: 'audio/webm;codecs=opus'
                }
            };
            navigator.mediaDevices.getUserMedia(options).then((stream) => {
                const mediaRecorder = new MediaRecorder(stream, {

                    mimeType: 'audio/webm',
                    audioSampleRate: 8000, // 
                    //AudioEncoder: "AAC"//指定音频编码器，例如AAC、AMR-NB、AMR-WB等。

                });
                const chunks = [];

                const audioCtx = new AudioContext();
                const decoder = new OpusToPCM({
                    channels: 1
                });


                decoder.on("decode", (pcmData) => {
                    console.log(pcmData);
                });

                mediaRecorder.addEventListener('dataavailable', (event) => {
                    chunks.push(event.data);

                    var data = new Uint8Array(event.data);

                    audioCtx.decodeAudioData(data.buffer, (buf) => {
                        decoder.decode(buf);
                    })

                });

                mediaRecorder.addEventListener('stop', () => {
                    //const blob = new Blob(chunks, { type: 'audio/pcm; codecs=pcm' });
                    const blob = new Blob(chunks, { type: 'audio/webm;codecs=opus' });
                    that.getVideo(blob);
                });

                // 开始录制
                mediaRecorder.start();
                window.mediaRecorder = mediaRecorder;
                this.startTime = this.getTimeStampAfterSeconds(0);
                this.endTime = this.getTimeStampAfterSeconds(this.sumTime * 100);
                this.showTime = true;
            }).catch((error) => {
                console.error('无法录制音频', error);
            });
        },

        openAudio() {
            const audio = document.getElementById("myAudio");
            audio.play();
        },
        reset() {
            this.start = false;
            this.stop = false;
            this.startTime = undefined;
            this.endTime = undefined;
            this.audioUrl = "";
            this.showTime = false;
        },
        stopAudio() {
            this.stop = true;
            this.showTime = false;
            var blob = recorderWavUti.stop();
            this.getVideo(blob);
        },
        getVideo(blob) {
            var file = this.blobToFile(blob, new Date().getTime() + ".wav");
            this.ruleForm.file = file;

            // 将Blob对象转换为URL
            this.audioUrl = "";
            const audioUrl = URL.createObjectURL(blob);
            this.audioUrl = audioUrl;
            console.log(audioUrl);
        },
        //下载文件
        downloadFile(file) {
            const url = URL.createObjectURL(file);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = file.name;
            a.click();
            window.URL.revokeObjectURL(url);
        },
        blobToFile(blob, fileName) {
            return new File([blob], fileName, { type: "audio/wav" });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var formdata = new FormData();
                    formdata.append("file", this.ruleForm.file);
                    formdata.append("cardNumber", this.ruleForm.receiveCardNumber);
                    postCommonAjax("/voice/uploadWav", formdata).then(() => {
                        this.$message({
                            message: "发送成功",
                            type: "success",
                        });
                        this.ruleForm.file = undefined;
                        this.$bus.$emit("maintenance-list");
                        this.$parent.close();
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
    created() {
        this.ruleForm.receiveCardNumber = this.subData.model.split("_")[1];
        this.getHistoryMessage(this.ruleForm.receiveCardNumber);
        this.getZhjMsg();
    },
    mounted() {
        recorderWavUti = new RecorderWav({
            success: () => {
                this.startTime = this.getTimeStampAfterSeconds(0);
                this.endTime = this.getTimeStampAfterSeconds(this.sumTime);
                this.showTime = true;
            }
        });

        recorderWavUti.init();
    },
    beforeDestroy() {
        recorderWavUti.destory();
    }
};
</script>
<style lang="scss">
.audio-room{
    padding: 0 20px !important;
}
.audio-list {
    display: flex;
    width: 80%;
    margin: auto;
    align-items: center;
    // justify-content: space-between;
    flex-direction: row;
    border: #3AB0E3 solid 1px;
    margin-bottom: 16px;
    padding: 16px;
    box-sizing: border-box;
    flex-direction: column;
    height: 380px;
    overflow-y: auto;

    .infoBox {
        // margin-bottom: 16px;
        color: #666666;
    }

    .msg-item {
        display: flex;
        flex-direction: column;
        width: 100%;
        border-bottom: dashed 1px #666666;

        :last-child {
            border-bottom: none;
        }

        .el-image {
            width: 220px;
            margin: 10px 0;
        }

        span {
            font-weight: 400;
            color: #666666;
            font-size: 12px;
        }
    }

    .msg-item:last-child {
        border-bottom: none;
    }

    .right {
        align-items: end;
    }

    .left {
        align-items: start;
    }
}

.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}

.bottomMsg {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
}
</style>